import { render, staticRenderFns } from "./TopNavigationBar.vue?vue&type=template&id=cb801b56&scoped=true"
import script from "./TopNavigationBar.vue?vue&type=script&lang=ts"
export * from "./TopNavigationBar.vue?vue&type=script&lang=ts"
import style0 from "./TopNavigationBar.vue?vue&type=style&index=0&id=cb801b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb801b56",
  null
  
)

export default component.exports